import { render, staticRenderFns } from "./ManageNimbleUsers.vue?vue&type=template&id=4e1ec8c6&"
import script from "./ManageNimbleUsers.vue?vue&type=script&lang=js&"
export * from "./ManageNimbleUsers.vue?vue&type=script&lang=js&"
import style0 from "./ManageNimbleUsers.vue?vue&type=style&index=0&id=4e1ec8c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports